import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { apiError } from "@/lib/adminApi";

export default function AdminLogin() {
  const { admin, login } = useAdminAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(username, password);
      toast.success("Welcome back, admin");
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#080A0F] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center gap-3">
          <Logo />
          <span className="tag border border-[#F59E0B]/40 bg-[#F59E0B]/10 text-[#F59E0B]"><ShieldCheck size={11} /> Private Admin</span>
        </div>
        <form onSubmit={submit} className="card-mp p-6 sm:p-8">
          <h1 className="font-display text-2xl font-bold uppercase tracking-wide text-white">Admin Login</h1>
          <p className="mt-1 text-sm text-slate-400">Money Printer control room. Authorised staff only.</p>

          <label className="mt-6 block font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Username</label>
          <input
            data-testid="admin-login-username-input"
            className="admin-input mt-1.5"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
          />
          <label className="mt-4 block font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Password</label>
          <input
            data-testid="admin-login-password-input"
            type="password"
            className="admin-input mt-1.5"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          {error && <p data-testid="admin-login-error" className="mt-3 text-sm text-[#EF4444]">{error}</p>}
          <button data-testid="admin-login-submit-button" disabled={busy} className="btn-primary mt-6 w-full justify-center disabled:opacity-60">
            <Lock size={14} /> {busy ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
